export function useIsAdmin() {
  const { user } = useUserSession()

  return isAdmin(user)
}
